import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AgentValidationType} from "../../types/agentValidation.type";
import {AgentPairingType} from "../../types/agentPairing.type";
import {OnOffDefaultType} from "../../../commons/types/onOffDefault.type";

export class AgentPreferencesPanelCtrl implements IController {

  preferences: any;
  selectedCount: any;

  onApply: Function;
  onCancel: Function;

  public onOffDefaultOptions: OnOffDefaultType[];
  private agentStatuses: any;
  private languages: any;
  private regions: any;

  private isExpanded: any;
  private preferencesCopy: any;
  private changesMap: any;
  private changesCount: any;
  public agentValidationTypesMap: typeof AgentValidationType = AgentValidationType;
  public agentPairingTypesMap: typeof AgentPairingType = AgentPairingType;
  public validationOptions;
  public pairingOptions;

  /* @ngInject */
  constructor(private splitConstants, private agentStatus) {
    this.onOffDefaultOptions = Object.values(OnOffDefaultType);
  }

  $onInit() {
    this.agentStatuses = this.agentStatus.statusToTitle;
    this.languages = this.splitConstants.languages;
    this.regions = this.splitConstants.countries;
    this.validationOptions = angular.copy(Object.values(AgentValidationType));
    this.pairingOptions = angular.copy(Object.values(AgentPairingType));
    this.isExpanded = {
      driverApp: false,
      preferences: false,
      configurationProfile: false
    }

    this.preferencesCopy = angular.copy(this.preferences);
    this.changesCount = {count: 0};
    this._setPairingOptions();

  };

  $onChanges(changes) {
    if (changes.preferences && !changes.preferences.isFirstChange()) {
      this.preferencesCopy = angular.copy(this.preferences);
      this.changesCount = {count: 0};
    }
  }

  onActiveChange() {
    const originalSettingsMap = Object.assign({},
      this.preferences.userFeatures,
      this.preferences.applicationFeatures,
      this.preferences.agentPreferences,
      {status: this.preferences.status, appAccess: this.preferences.appAccess});

    const copySettingsMap = Object.assign({},
      this.preferencesCopy.userFeatures,
      this.preferencesCopy.applicationFeatures,
      this.preferencesCopy.agentPreferences,
      {status: this.preferencesCopy.status, appAccess: this.preferencesCopy.appAccess});

    let changesCount = 0;

    this.changesMap = _.mapValues(originalSettingsMap, (value, key) => {
      const hasChanged = !_.isEqual(value, copySettingsMap[key]);

      if (hasChanged) {
        changesCount++;
      }

      return hasChanged;
    });

    this.changesCount = {count: changesCount};
  }

  onRevertChange(settingsRef) {
    _.set(this.preferencesCopy, settingsRef, undefined);
    this.onActiveChange();
  }

  onChangeStatus(status) {
    this.preferencesCopy.status = status;
    this.onActiveChange();
  }

  onChangeLanguage(localeCode) {
    this.preferencesCopy.userFeatures.localeCode = localeCode;
    this.onActiveChange();
  }

  onChangeCountry(countryCode) {
    this.preferencesCopy.userFeatures.countryCode = countryCode;
    this.onActiveChange();
  }

  onConfigurationProfileSelect(profileId: string) {
    this.preferencesCopy.agentConfigurationProfileId = profileId;
  }

  onChangeValidateBy(validationOption) {
    this._setPairingOptions();

    if (validationOption === AgentValidationType.Barcode) {
      if (!_.includes(this.pairingOptions, this.preferencesCopy.agentPreferences.pairingOption)) {
        this.preferencesCopy.agentPreferences.pairingOption = AgentPairingType.Barcode;
      }
    } else if (validationOption === AgentValidationType.ProNumber) {
      this.preferencesCopy.agentPreferences.pairingOption = AgentPairingType.ProNumber;
    } else if (validationOption === AgentValidationType.None) {
      this.preferencesCopy.agentPreferences.quickValidation = false;
      this.preferencesCopy.agentPreferences.forceValidation = false;
      if (!_.includes(this.pairingOptions, this.preferencesCopy.agentPreferences.pairingOption)) {
        this.preferencesCopy.agentPreferences.pairingOption = AgentPairingType.None;
      }
    } else if (validationOption === AgentValidationType.Click) {
      if (!_.includes(this.pairingOptions, this.preferencesCopy.agentPreferences.pairingOption)) {
        this.preferencesCopy.agentPreferences.pairingOption = AgentPairingType.None;
      }
    }
    this.onActiveChange();
  }

  onReset() {
    this.preferencesCopy = angular.copy(this.preferences);
    this.onActiveChange();
  }

  onForcePairingChange(forcePairing) {
    if (!!forcePairing) {
      this.pairingOptions = [AgentPairingType.ProNumber, AgentPairingType.Barcode];
      if (!_.includes(this.pairingOptions, this.preferencesCopy.agentPreferences.pairingOption)) {
        this.preferencesCopy.agentPreferences.pairingOption = this.pairingOptions[0];
      }
    }
    this.onActiveChange();
  }

  onPairingOptionChange(pairingOption) {
    if (pairingOption === AgentPairingType.Barcode) {
      this.preferencesCopy.agentPreferences.quickValidation = false;
      this.validationOptions = [AgentValidationType.None, AgentValidationType.Barcode, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.preferencesCopy.agentPreferences.validationOption)) {
        this.preferencesCopy.agentPreferences.validationOption = AgentValidationType.Barcode;
      }
    } else if (pairingOption === AgentPairingType.None) {
      this.validationOptions = angular.copy(Object.values(AgentValidationType));
      this.preferencesCopy.agentPreferences.forcePairing = false;
    } else if (pairingOption === AgentPairingType.ProNumber) {
      this.validationOptions = [AgentValidationType.None, AgentValidationType.ProNumber, AgentValidationType.Click];
      if (!_.includes(this.validationOptions, this.preferencesCopy.agentPreferences.validationOption)) {
        this.preferencesCopy.agentPreferences.validationOption = AgentValidationType.ProNumber;
      }
    }
    this.onActiveChange()
  }

  private _setPairingOptions() {
    if (this.preferencesCopy.agentPreferences.validationOption === AgentValidationType.Barcode) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.Barcode];
    } else if (this.preferencesCopy.agentPreferences.validationOption === AgentValidationType.ProNumber) {
      this.pairingOptions = [AgentPairingType.ProNumber];
    } else if (this.preferencesCopy.agentPreferences.validationOption === AgentValidationType.None) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    } else if (this.preferencesCopy.agentPreferences.validationOption === AgentValidationType.Click) {
      this.pairingOptions = [AgentPairingType.None, AgentPairingType.ProNumber, AgentPairingType.Barcode];
    }
  }

  onSubmit(preferencesCopy, form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.onApply({preferences: preferencesCopy});
      }
    }
  }

  onTagsToAddChange(tagNames) {
    this.preferencesCopy.tagsToAdd = tagNames;
  }

  onTagsToRemoveChange(tagNames) {
    this.preferencesCopy.tagsToRemove = tagNames;
  }

  onBranchesToAddSelect(branchIds) {
    this.preferencesCopy.branchIds = branchIds;
  }

  onBranchesToRemoveSelect(branchIds) {
    this.preferencesCopy.branchIdsToRemove = branchIds;
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentPreferencesPanel', {
    bindings: {
      preferences: '<',
      selectedCount: '<?',
      onApply: '&',
      onCancel: '&'
    },
    template: require('./agent-preferences-panel.html').default,
    controller: AgentPreferencesPanelCtrl
  });
